// src/api/useFetchObject.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const hasAuthToken = (token) =>
  typeof token === "string" ? token.trim().length > 0 : Boolean(token);

const useFetchObject = (queryKey, endpoint, id, token, options = {}) => {
  const { requiresAuth = true, enabled, ...queryOptions } = options;

  const baseEnabled =
    queryKey != null &&
    endpoint !== "" &&
    id !== undefined &&
    id !== null &&
    id !== "" &&
    (!requiresAuth || hasAuthToken(token));
  const shouldEnable = enabled !== undefined ? Boolean(enabled) && baseEnabled : baseEnabled;

  const fetchFunction = async () => {
    const headers = hasAuthToken(token) ? { Authorization: `Token ${String(token).trim()}` } : {};
    const response = await axios.get(`${endpoint}/${id}/`, { headers });
    return response.data;
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [queryKey, endpoint, id],
    queryFn: fetchFunction,
    enabled: shouldEnable,
    retry: (failureCount, err) => {
      const status = err?.response?.status;
      if (status === 400 || status === 401 || status === 403 || status === 404) {
        return false;
      }
      return failureCount < 2;
    },
    ...queryOptions,
  });

  return { data, isLoading, isError, error };
};

export default useFetchObject;
